import { useQuery } from "@tanstack/react-query";
import { aiconfigService } from "@/lib/api/services/aiconfig.service";
import { aiconfigKeys } from "@/hooks/api/keys/aiconfig-readiness.keys";
import type { UseCase, ReadinessReason } from "@/types/llm-readiness.types";

export interface ReadinessQueryOptions {
  enabled?: boolean;
  refetchOnMount?: boolean | "always";
}

export function useAiConfigReadiness(options: ReadinessQueryOptions = {}) {
  const query = useQuery({
    queryKey: aiconfigKeys.readiness(),
    queryFn: () => aiconfigService.getReadiness(),
    enabled: options.enabled ?? true,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    ...(options.refetchOnMount !== undefined ? { refetchOnMount: options.refetchOnMount } : {}),
  });

  const isReady = (useCase: UseCase): boolean =>
    query.data?.useCases?.[useCase]?.ready ?? false;

  const getReason = (useCase: UseCase): ReadinessReason | null =>
    query.data?.useCases?.[useCase]?.reason ?? null;

  return { ...query, isReady, getReason };
}
